const OPEN_MODE = {
  DROP_DOWN: 'DROP_DOWN',
  POP_UP: 'POP_UP',
};

export default OPEN_MODE;
